.shipment-limit-container {
  display: grid;
  grid-template-rows: subgrid;
  grid-template-columns: subgrid;
  grid-row: var(--lineup-plan-grid-row-shipment-limit-label) / var(--lineup-plan-grid-row-user-count-label);
  gap: var(--space-0);
}

.shipment-dropdown-label {
  grid-area: shipment-limit-label;
  color: var(--gray-212c36);
}

.shipment-dropdown {
  grid-area: shipment-limit;
  width: 100%;
}

.shipment-dropdown-toggler {
  height: 32px;

  @media (--tablet), (--mobile), (--ultramobile) {
    height: auto;
    min-height: 32px;
  }
}

.shipment-dropdown-toggler-has-discount {
  height: auto;
  min-height: 32px;
}

.promo-border {
  border: 2px solid var(--purple-8D30F7) !important;
}

.coupon-border {
  border: 2px solid var(--blue-1D5AD8) !important;
}

.shipment-limit-dropdown-toggler-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-8);
}

.shipment-limit-dropdown-menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-8);

  padding: 5px var(--space-8);
}

.read-only-shipments {
  grid-area: shipment-limit;
  display: flex;
  align-items: center;
}
